export function formatEUR(value) {
  if (value === null || value === undefined) return "—";
  try {
    return new Intl.NumberFormat("it-IT", {
      style: "currency",
      currency: "EUR",
      maximumFractionDigits: 0,
    }).format(value);
  } catch {
    return `€${value}`;
  }
}

export function formatTimeLeft(seconds) {
  if (seconds === null || seconds === undefined) return null;
  if (seconds <= 0) return "Asta conclusa";
  const days = Math.floor(seconds / 86400);
  const hours = Math.floor((seconds % 86400) / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  if (days >= 1) return `${days}g ${hours}h`;
  if (hours >= 1) return `${hours}h ${minutes}m`;
  if (minutes >= 1) return `${minutes}m`;
  return `${seconds}s`;
}

export function timeUrgency(seconds) {
  if (seconds === null || seconds === undefined) return "neutral";
  if (seconds <= 3600) return "urgent"; // <1h
  if (seconds <= 24 * 3600) return "soon"; // <1d
  return "neutral";
}
